/* eslint-disable no-undef */
import axios from "axios";
import router from "@/modules/global/router";
import store from "@/modules/global/stores";

var http = axios.create({
    baseURL: process.env.API_BASE_URL + "account",
    headers: { "Content-Type": "application/json" },
});

http.interceptors.response.use(
    function (response) {
        return response;
    },

    function (error) {
        if (error.response.status !== 401) return Promise.reject(error);
        var refreshAndRetry = new Promise(function (resolve) {
            axios
                .post(
                    process.env.API_BASE_URL + "account/refresh_token",
                    {
                        // eslint-disable-next-line no-undef
                        refresh_token: JSON.parse(
                            localStorage.getItem("refresh_token")
                        ).value,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            // eslint-disable-next-line no-undef
                            Authorization:
                                "Bearer " +
                                JSON.parse(localStorage.getItem("token")).value,
                        },
                    }
                )
                .then(function (response) {
                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "refresh_token",
                        JSON.stringify({
                            value: response.data.refresh_token,
                            expire: null,
                        })
                    );

                    // eslint-disable-next-line no-undef
                    localStorage.setItem(
                        "token",
                        JSON.stringify({
                            value: response.data.token,
                            expire: null,
                        })
                    );

                    return Promise.resolve(response);
                })
                .catch(function (err) {
                    var failedRequest = err.config;
                    // eslint-disable-next-line no-undef
                    var token = localStorage.getItem("token");
                    doLogout(token, function (result) {
                        if (result.success) {
                            localStorage.clear();
                            store.commit("auth_destroyed");
                            router.push("/");
                        }
                    });

                    // eslint-disable-next-line no-undef
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                });
        });

        return refreshAndRetry;
    }
);

function getConfig() {
    return {
        headers: {
            // eslint-disable-next-line no-undef
            Authorization: JSON.parse(localStorage.getItem("token")).value,
        },
    };
}

async function doLogin(email, password, callback) {
    await axios
        .post(process.env.API_BASE_URL + "account/basic_login", {
            email: email,
            password: password,
        })
        .then(function (response) {
            var data = {
                success: true,
                data: {
                    id: response.data.id,
                    email: response.data.email,
                    name: response.data.name,
                    firstName: response.data.first_name,
                    lastName: response.data.lastName,
                    phoneNumber: response.data.phone_number,
                    token: response.data.token,
                    picture: response.data.picture,
                    refreshToken: response.data.refresh_token,
                },
            };
            callback(data);
        })
        .catch(function (error) {
            var data = {
                success: false,
                message: error.response.data.message,
            };
            callback(data);
        });
}

async function doLogout(token, callback) {
    var data = {};
    var config = {
        headers: {
            "Content-Type": "application/json",
            // eslint-disable-next-line no-undef
            Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token")).value,
        },
    };

    await http
        .post("logout", data, config)
        .then(function (response) {
            var data = {
                success: true,
                message: "You have successfully logged out",
            };
            callback(data);
        })
        .catch(function (error) {
            var data = {
                success: false,
                message: error.response
                    ? error.response.data.message
                    : "terjadi kesalahan",
            };
            callback(data);
        });
}

async function doValidateToken(token, callback) {
    await http
        .post(process.env.API_BASE_URL + "account/validate_token", {
            token: token,
        })
        .then(function (response) {
            var data = {
                success: true,
                scopes: response.data.user_scopes,
            };
            callback(data);
        })
        .catch(function (error) {
            var data = {
                success: false,
                message: error.response.data.message,
            };
            if (!data.success || error.response.data.error === "Unauthorized") {
                doLogout(token, function (result) {
                    if (result.success) {
                        localStorage.clear();
                        store.commit("auth_destroyed");
                        router.push("/login");
                    }
                });
            }
            callback(data);
        });
}

function userActivation(userId, email, studentNumber, callback) {
    var data = {
        user_id: userId,
        email: email,
        student_number: studentNumber,
    };

    var config = getConfig();
    http.post("activation/third_party", data, config)
        .then(function (response) {
            var data = {
                success: true,
                data: response.data,
            };
            callback(data);
        })
        .catch(function (error) {
            var data = {
                success: false,
                message: error.response.data.message,
            };
            callback(data);
        });
}

function userActivationGeneral(datas, callback) {
    var config = getConfig();

    http.post("activation/admin/payment", datas, config)
        .then(function (response) {
            var data = {
                success: true,
                data: response.data,
            };
            callback(data);
        })
        .catch(function (error) {
            var data = {
                success: false,
                message: error.response.data.message,
            };
            callback(data);
        });
}

function changeSchedule(datas, callback) {
    var params = {
        id: datas.id,
        group_id: datas.group_id,
    };

    var config = getConfig();
    http.put("admin/change/schedule", params, config)
        .then(function (response) {
            var data = {
                success: true,
                data: response.data,
            };
            callback(data);
        })
        .catch(function (error) {
            var data = {
                success: false,
                message: error.response.data.message,
            };
            callback(data);
        });
}

export default {
    doLogin,
    doLogout,
    doValidateToken,
    userActivation,
    userActivationGeneral,
    changeSchedule,
};



// WEBPACK FOOTER //
// ./src/modules/auth/services/auth.js